import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'NPV',
    fullName: "Núcleo de Prevenção à Violência",
    tagline: "Reconhecer, cuidar e prevenir",
    description:
        "Nove formas de violência explicadas, canais de ajuda gratuitos, guias práticos e as vozes pioneiras da violência e saúde no Brasil. Um site do Núcleo de Prevenção à Violência.",
    url: getOrigin(),
    ogImage: '/visionaries/eclipse.jpg'
}
